import React from 'react';

import { Skeleton } from '../loading';

// How many placeholders a first load draws. A hint at the shape, not a count:
// enough to fill a laptop screen's first view, few enough to stay cheap.
export const TABLE_SKELETON_ROWS = 8;
export const TILE_SKELETON_COUNT = 6;

/**
 * The loading-initial placeholder for the items list (docs/platform-standards.md
 * §14): table rows for the table view, tiles for the tile grid. Generic per
 * surface type, never per card (per-card mirroring is a later slice).
 *
 * The tiles sit in the same `item-card-grid` the real tiles do, so they take
 * the same columns, gaps and — through items-list-loading.css — height.
 */
export default function ItemsListSkeleton({ variant = 'tiles', className = '' }) {
	if (variant === 'table') {
		return (
			<div className={`items-list-skeleton items-list-skeleton--table${className ? ` ${className}` : ''}`}>
				<Skeleton variant="table-row" count={TABLE_SKELETON_ROWS} columns={4} />
			</div>
		);
	}
	return (
		<div className={`item-card-grid items-list-skeleton items-list-skeleton--tiles${className ? ` ${className}` : ''}`}>
			{Array.from({ length: TILE_SKELETON_COUNT }, (_, index) => (
				<Skeleton key={index} variant="tile" />
			))}
		</div>
	);
}
